import { Application } from 'stimulus';
import { RootController } from '../../designs/paper';

import './styles/style.scss';

let app = Application.start();

app.register('root', RootController);
